import { GeneralService } from './../../../services/general.service';
import { FormGroup } from '@angular/forms';

export class FormSec002Build {

    public areaSelect: string = localStorage.getItem('area-select') || null;
    public buildForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): FormGroup {
        this.buildFormI(form, arrForm[0], generalService);
        this.buildFormII(form, arrForm[1], generalService);
        this.buildFormIII(form, arrForm[2], generalService);
        this.buildFormIV(form, arrForm[3], generalService);
        this.buildFormV(form, arrForm[4], generalService);
        this.buildFormVI(form, arrForm[5], generalService);
        this.buildFormVII(form, arrForm[6], generalService);
        this.buildFormVIII(form, arrForm[7], generalService);
        this.buildFormIX(form, arrForm[8], generalService);
        this.buildFormX(form, arrForm[9], generalService);
        return form;
    }

    private buildFormI(form: FormGroup, formCard: FormGroup, generalService: GeneralService): FormGroup {

        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('site_recebimento').setValue(formCard.get('Site_recebimento')?.value);
            form.get('safra').setValue(formCard.get('safra')?.value);
            form.get('safra_basica').setValue(formCard.get('safra_basica')?.value);
            form.get('cerar_basica').setValue(formCard.get('cerar_basica')?.value);
            form.get('n_de_campo_basica').setValue(formCard.get('n_de_campo_basica')?.value);
            form.get('gleba').setValue(formCard.get('gleba')?.value);
            form.get('geracao_basica').setValue(formCard.get('geracao_basica')?.value);
            form.get('numero_caixa').setValue(formCard.get('numero_caixa')?.value);
            form.get('controle_caixa').setValue(formCard.get('controle_caixa')?.value);
            form.get('peso_rw_kg_total').setValue(formCard.get('peso_rw_kg_total')?.value);
            form.get('umidade_recebimento').setValue(formCard.get('umidade_recebimento')?.value);
            form.get('tipo_colheita').setValue(formCard.get('tipo_colheita')?.value);
            form.get('contrato_campo').setValue(formCard.get('contrato_campo')?.value);
            form.get('hibrido_rnc_linhagem').setValue(formCard.get('hibrido_rnc_linhagem')?.value);
            form.get('cooperante').setValue(formCard.get('cooperante')?.value);
            form.get('altura_camada_m').setValue(formCard.get('altura_camada_m')?.value);
            form.get('houve_troca_caixa').setValue(formCard.get('houve_troca_caixa')?.value);
            form.get('numero_novo_caixa').setValue(formCard.get('numero_novo_caixa')?.value);
            form.get('lote_rw').setValue(formCard.get('lote_rw')?.value);
            form.get('nota_ardida').setValue(formCard.get('nota_ardida')?.value);
        }
        else {
            form.get('site_recebimento').setValue(formCard.get('Site_recebimento')?.value);
            form.get('site_origem').setValue(formCard.get('Site_origem')?.value);
            form.get('safra').setValue(formCard.get('Safra')?.value);
            form.get('controle_secagem').setValue(formCard.get('Controle_secagem')?.value);
            form.get('secador_camara').setValue(formCard.get('Secador_camara')?.value);
            form.get('tipo_colheita').setValue(formCard.get('Tipo_colheita')?.value);
            form.get('contrato_campo').setValue(formCard.get('Contrato_campo')?.value);
            form.get('contrato_campo_2').setValue(formCard.get('Contrato_campo_2')?.value);
            form.get('n_de_campo_basica').setValue(formCard.get('Num_campo')?.value);
            form.get('hibrido_rnc_linhagem').setValue(formCard.get('Hibrido_rnc_linhagem')?.value);
            form.get('geracao_basica').setValue(formCard.get('Geracao')?.value);
            form.get('especie_basica').setValue(formCard.get('Especie')?.value);
            // tslint:disable-next-line: max-line-length
            form.get('inicio_enchimento').setValue(generalService.createDateTimeData(formCard.get('Inicio_enchimento_data')?.value, formCard.get('Inicio_enchimento_hora')?.value));
            // tslint:disable-next-line: max-line-length
            form.get('termino_enchimento').setValue(generalService.createDateTimeData(formCard.get('Termino_enchimento_data')?.value, formCard.get('Termino_enchimento_hora')?.value));
            form.get('peso_rw_kg_total').setValue(formCard.get('Peso_rw_kg_total')?.value);
            form.get('umidade_media_cerar').setValue(formCard.get('Umidade_media_cerar')?.value);
            //form.get('justificativa_camara').setValue(formCard.get('Justificativa_camara')?.value);
            form.get('gleba').setValue(formCard.get('gleba')?.value);
        }

        return form;
    }

    private buildFormII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): FormGroup {
        if (this.areaSelect.includes('Básica') || this.areaSelect.includes('Comercial')) {
            form.get('inicio_secagem').setValue(generalService.createDateTimeData(formCard.get('Inicio_secagem_data')?.value, formCard.get('Inicio_secagem_hora')?.value));
            form.get('inversao_camara').setValue(generalService.createDateTimeData(formCard.get('Inversao_camara_data')?.value, formCard.get('Inversao_camara_hora')?.value));
            form.get('termino_secagem').setValue(generalService.createDateTimeData(formCard.get('Termino_secagem_data')?.value, formCard.get('Termino_secagem_hora')?.value));
            form.get('data_amostragem').setValue(generalService.createDateTimeData(formCard.get('data_amostragem')?.value, formCard.get('hora_amostragem')?.value));
            form.get('umidade_amostra').setValue(formCard.get('umidade_amostra')?.value);
            form.get('optek_amostra').setValue(formCard.get('optek_amostra')?.value);
            form.get('umidade_media_de_fechamento_avm').setValue(formCard.get('Umidade_media_fechamento_av')?.value);
            form.get('umidade_topo_de_fechamento_moff').setValue(formCard.get('Umidade_topo_de_fechamento_moff')?.value);
            form.get('ressecagem').setValue(formCard.get('Ressecagem')?.value);
            form.get('altura_camada_m').setValue(formCard.get('Altura_camada_m')?.value);
            form.get('avaliacao_nivelamento').setValue(formCard.get('avaliacao_nivelamento')?.value);
            form.get('observacao_nivelamento').setValue(formCard.get('observacao_nivelamento')?.value);
            // tslint:disable-next-line: max-line-length
            form.get('inicio_ressecagem').setValue(generalService.createDateTimeData(formCard.get('Inicio_ressecagem_data')?.value, formCard.get('Inicio_ressecagem_hora')?.value));
            // tslint:disable-next-line: max-line-length
            form.get('termino_ressecagem').setValue(generalService.createDateTimeData(formCard.get('Termino_ressecagem_data')?.value, formCard.get('Termino_ressecagem_hora')?.value));
        }

        return form;
    }

    private buildFormIII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): FormGroup {
        form.get('inicio_debulha').setValue(generalService.createDateTimeData(formCard.get('Inicio_debulha_data')?.value, formCard.get('Inicio_debulha_hora')?.value));
        form.get('termino_debulha').setValue(generalService.createDateTimeData(formCard.get('Termino_debulha_data')?.value, formCard.get('Termino_debulha_hora')?.value));
        form.get('motivo_espera_debulha').setValue(formCard.get('Motivo_espera_debulha')?.value);
        form.get('umidade_minima').setValue(formCard.get('Umidade_minima')?.value);
        form.get('umidade_maxima').setValue(formCard.get('Umidade_maxima')?.value);
        form.get('umidade_debulha_media').setValue(formCard.get('Umidade_debulha_media')?.value);
        form.get('desvio_padrao').setValue(formCard.get('Desvio_padrao')?.value);
        form.get('peneira_topo_utilizada').setValue(formCard.get('Peneira_topo_utilizada')?.value);
        form.get('retido_na_peneira_topo').setValue(formCard.get('Retido_na_peneira_topo')?.value);
        form.get('peneira_fundo_utilizada').setValue(formCard.get('Peneira_fundo_utilizada')?.value);
        form.get('vazado_na_peneira_fundo').setValue(formCard.get('Vazado_na_peneira_fundo')?.value);
        form.get('linha_da_debulha').setValue(formCard.get('Linha_da_debulha')?.value);
        return form;
    }

    private buildFormIV(form: FormGroup, formCard: FormGroup, generalService: GeneralService): FormGroup {
        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('secagem_horas').setValue(formCard.get('secagem_horas')?.value);
            form.get('ressecagem_horas').setValue(formCard.get('ressecagem_horas')?.value);
            form.get('tempo_de_patio').setValue(formCard.get('tempo_de_patio')?.value);
        }
        else {
            form.get('enchimento_horas_atividade_1010').setValue(formCard.get('Enchimento_horas_atividade_1010')?.value);
            form.get('primeiro_ciclo_horas').setValue(formCard.get('Primeiro_ciclo_horas')?.value);
            form.get('segundo_ciclo_horas').setValue(formCard.get('Segundo_ciclo_horas')?.value);
            form.get('ressecagem_horas').setValue(formCard.get('Ressecagem_horas')?.value);
            form.get('secagem_horas_atividade_2010').setValue(formCard.get('Secagem_horas_atividade_2010')?.value);
            form.get('espera_horas').setValue(formCard.get('Espera_horas')?.value);
            form.get('debulha_horas_atividade_3010').setValue(formCard.get('Debulha_horas_atividade_3010')?.value);

        }
        return form;
    }

    private buildFormV(form: FormGroup, formCard: FormGroup, generalService: GeneralService): FormGroup {
        // form.get('peso_debulha_kg').setValue(formCard.get('Peso_debulha_kg')?.value);
        // form.get('lote_ds').setValue(formCard.get('Lote_ds')?.value);
        //  form.get('silo_destino').setValue(formCard.get('Silo_destino')?.value);
        form.get('status_silo').setValue(formCard.get('Status_silo')?.value);
        form.get('ordem_ds').setValue(formCard.get('Ordem_ds')?.value);
        form.get('peso_debulha_kg_total').setValue(formCard.get('peso_debulha_kg_total')?.value);
        form.get('volume_calda_litros').setValue(formCard.get('Volume_calda_litros')?.value);
        form.get('calda_por_tonelada_l_ton').setValue(formCard.get('Calda_por_tonelada_l_ton')?.value);
        form.get('concentracao_k_obiol').setValue(formCard.get('Concentracao_k_obiol')?.value);
        form.get('concentracao_actellic').setValue(formCard.get('Concentracao_actellic')?.value);
        form.get('k_obiol_litros').setValue(formCard.get('K_obiol_litros')?.value);
        form.get('actellic_litros').setValue(formCard.get('Actellic_litros')?.value);
        form.get('check_sap_rw').setValue(formCard.get('Check_sap_rw')?.value);
        form.get('check_sap_ds').setValue(formCard.get('Check_sap_ds')?.value);
        form.get('check_sap_quimicos').setValue(formCard.get('Check_sap_quimicos')?.value);
        return form;
    }

    private buildFormVI(form: FormGroup, formCard: FormGroup, generalService: GeneralService): FormGroup {

        // tslint:disable-next-line: max-line-length
        form.get('inicio_da_transilagem').setValue(generalService.createDateTimeData(formCard.get('Inicio_transilagem_data')?.value, formCard.get('Inicio_transilagem_hora')?.value));
        form.get('silo_destino_transilagem').setValue(formCard.get('Silo_destino_transilagem')?.value);
        form.get('motivo').setValue(formCard.get('Motivo')?.value);
        form.get('inicio_da_retirada_para_armazem').setValue(generalService.createDateTimeData(formCard.get('Inicio_retirada_armazem_data')?.value, formCard.get('Inicio_retirada_armazem_hora')?.value));
        form.get('inicio_da_retorno_silo').setValue(generalService.createDateTimeData(formCard.get('Inicio_retorno_silo_data')?.value, formCard.get('Inicio_retorno_silo_hora')?.value));
        form.get('silo_de_destino_retorno').setValue(formCard.get('Silo_destino_retorno')?.value);
        form.get('local_atual').setValue(formCard.get('Local_atual')?.value);
        form.get('inicio_descarga_silo').setValue(generalService.createDateTimeData(formCard.get('Inicio_descarga_silo_data')?.value, formCard.get('Inicio_descarga_silo_hora')?.value));
        form.get('destino_ds_final').setValue(formCard.get('Destino_ds_final')?.value);
        form.get('armazenagem_dias').setValue(formCard.get('Armazenagem_dias')?.value);

        return form;
    }

    private buildFormVII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): FormGroup {
        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('faixa_azul_campo').setValue(formCard.get('Faixa_azul_campo')?.value);
            form.get('faixa_azul_umidade_de_colheita').setValue(formCard.get('Faixa_azul_umidade_de_colheita')?.value);
            form.get('faixa_azul_ressecagem').setValue(formCard.get('Faixa_azul_ressecagem')?.value);
            form.get('faixa_azul_tempo_de_patio').setValue(formCard.get('faixa_azul_tempo_de_patio')?.value);
        }
        else {
            form.get('faixa_azul_campo').setValue(formCard.get('Faixa_azul_campo')?.value);
            form.get('faixa_azul_umidade_de_colheita').setValue(formCard.get('Faixa_azul_umidade_de_colheita')?.value);
            form.get('faixa_azul_temperatura_de_secagem').setValue(formCard.get('Faixa_azul_temperatura_de_secagem')?.value);
            form.get('faixa_azul_sem_vapor_ou_ventilacao').setValue(formCard.get('Faixa_azul_sem_vapor_ou_ventilacao')?.value);
            form.get('faixa_azul_ressecagem').setValue(formCard.get('Faixa_azul_ressecagem')?.value);
            form.get('faixa_azul_transbordo').setValue(formCard.get('Faixa_azul_transbordo')?.value);
            form.get('faixa_azul_claro_temperatura_carga').setValue(formCard.get('Faixa_azul_claro_temperatura_carga')?.value);
            form.get('faixa_azul_claro_tempo_de_patio').setValue(formCard.get('Faixa_azul_claro_tempo_de_patio')?.value);
            // tslint:disable-next-line: max-line-length
            form.get('faixa_azul_escuro_temperatura_carga').setValue(formCard.get('Faixa_azul_escuro_temperatura_carga')?.value);
            form.get('faixa_azul_escuro_tempo_de_patio').setValue(formCard.get('Faixa_azul_escuro_tempo_de_patio')?.value);
            // tslint:disable-next-line: max-line-length
            form.get('faixa_azul_escuro_granel_tempo_de_transporte').setValue(formCard.get('Faixa_azul_escuro_granel_tempo_de_transporte')?.value);

        }
        return form;
    }

    private buildFormVIII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): FormGroup {
        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('faixa_vermelha').setValue(formCard.get('Faixa_vermelha')?.value);
            // form.get('faixa_marrom').setValue(formCard.get('Faixa_marrom')?.value);
        }
        else {
            form.get('faixa_vermelha').setValue(formCard.get('Faixa_vermelha')?.value);
            form.get('faixa_roxa').setValue(formCard.get('Faixa_roxa')?.value);
            //form.get('faixa_marrom').setValue(formCard.get('Faixa_marrom')?.value);
        }
        return form;
    }

    private buildFormIX(form: FormGroup, formCard: FormGroup, generalService: GeneralService): FormGroup {
        form.get('faixa_laranja').setValue(formCard.get('Faixa_laranja')?.value);
        form.get('faixa_cinza').setValue(formCard.get('Faixa_cinza')?.value);
        return form;
    }

    private buildFormX(form: FormGroup, formCard: FormGroup, generalService: GeneralService): FormGroup {
        form.get('observacao').setValue(formCard.get('Observacao')?.value);
        form.get('created_by').setValue(formCard.get('criado_por')?.value);
        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('responsavel').setValue(formCard.get('responsavel')?.value);
        }
        return form;
    }

    public updateForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): void {
        this.updateFormI(form, arrForm[0], generalService);
        this.updateFormII(form, arrForm[1], generalService);
        this.updateFormIII(form, arrForm[2], generalService);
        this.updateFormIV(form, arrForm[3], generalService);
        this.updateFormV(form, arrForm[4], generalService);
        this.updateFormVI(form, arrForm[5], generalService);
        this.updateFormVII(form, arrForm[6], generalService);
        this.updateFormVIII(form, arrForm[7], generalService);
        this.updateFormIX(form, arrForm[8], generalService);
        this.updateFormX(form, arrForm[9], generalService);
    }

    private updateFormI(data: any, formCard: FormGroup, generalService: GeneralService): void {
        if (this.areaSelect.includes('Pré-Básica')) {
            formCard.get('site_recebimento').setValue(data.formulario.site_recebimento);
            formCard.get('safra').setValue(data.formulario.safra);
            formCard.get('safra_basica').setValue(data.formulario.safra_basica);
            formCard.get('cerar_basica').setValue(data.formulario.cerar_basica);
            formCard.get('n_de_campo_basica').setValue(data.formulario.n_de_campo_basica);
            formCard.get('gleba').setValue(data.formulario.gleba);
            formCard.get('geracao_basica').setValue(data.formulario.geracao_basica);
            formCard.get('numero_caixa').setValue(data.formulario.numero_caixa);
            formCard.get('controle_caixa').setValue(data.formulario.controle_caixa);
            formCard.get('lote_rw').setValue(data.formulario.lote_rw);
            formCard.get('umidade_recebimento').setValue(data.formulario.umidade_recebimento);
            formCard.get('tipo_colheita').setValue(data.formulario.tipo_colheita);
            formCard.get('contrato_campo').setValue(data.formulario.contrato_campo);
            formCard.get('hibrido_rnc_linhagem').setValue(data.formulario.hibrido_rnc_linhagem);
            formCard.get('cooperante').setValue(data.formulario.cooperante);
            formCard.get('peso_rw_kg_total').setValue(data.formulario.peso_rw_kg_total);
            formCard.get('houve_troca_caixa').setValue(data.formulario?.houve_troca_caixa);
            formCard.get('numero_novo_caixa').setValue(data.formulario?.numero_novo_caixa);
            formCard.get('nota_ardida').setValue(data.formulario.nota_ardida);
        }
        else {
            formCard.get('Site_recebimento').setValue(data.formulario.site_recebimento);
            formCard.get('Site_origem').setValue(data.formulario.site_origem);
            formCard.get('Safra').setValue(data.formulario.safra);
            formCard.get('Tipo_colheita').setValue(data.formulario.tipo_colheita);
            formCard.get('Contrato_campo').setValue(data.formulario.contrato_campo);
            formCard.get('Contrato_campo_2').setValue(data.formulario.contrato_campo_2);
            formCard.get('Num_campo').setValue(data.formulario.n_de_campo_basica);
            formCard.get('Hibrido_rnc_linhagem').setValue(data.formulario.hibrido_rnc_linhagem);
            formCard.get('Geracao').setValue(data.formulario.geracao_basica);
            formCard.get('Especie').setValue(data.formulario.especie_basica);
            // tslint:disable-next-line: max-line-length
            formCard.get('Inicio_enchimento_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_enchimento, true));
            // tslint:disable-next-line: max-line-length
            formCard.get('Inicio_enchimento_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_enchimento, false));
            // tslint:disable-next-line: max-line-length
            formCard.get('Termino_enchimento_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.termino_enchimento, true));
            // tslint:disable-next-line: max-line-length
            formCard.get('Termino_enchimento_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.termino_enchimento, false));
            formCard.get('Peso_rw_kg_total').setValue(data.formulario.peso_rw_kg_total);
            formCard.get('Umidade_media_cerar').setValue(data.formulario.umidade_media_cerar);
            formCard.get('gleba')?.setValue(data.formulario.gleba);
        }

    }

    private updateFormII(data: any, formCard: FormGroup, generalService: GeneralService): void {
        if (!this.areaSelect.includes('Pré-Básica')) {
            formCard.get('Inicio_secagem_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_secagem, true));
            formCard.get('Inicio_secagem_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_secagem, false));
            formCard.get('Inversao_camara_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inversao_camara, true));
            formCard.get('data_amostragem').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.data_amostragem, true));
            formCard.get('hora_amostragem').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.data_amostragem, false));
            formCard.get('umidade_amostra').setValue(data.formulario.umidade_amostra);
            formCard.get('optek_amostra').setValue(data.formulario.optek_amostra);
            formCard.get('avaliacao_nivelamento').setValue(data.formulario.avaliacao_nivelamento);
            formCard.get('observacao_nivelamento').setValue(data.formulario.observacao_nivelamento);
            formCard.get('Inversao_camara_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inversao_camara, false));
            formCard.get('Termino_secagem_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.termino_secagem, true));
            formCard.get('Termino_secagem_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.termino_secagem, false));
            formCard.get('Umidade_media_fechamento_av').setValue(data.formulario.umidade_media_de_fechamento_avm);
            formCard.get('Umidade_topo_de_fechamento_moff').setValue(data.formulario.umidade_topo_de_fechamento_moff);
            formCard.get('Ressecagem').setValue(data.formulario.ressecagem);
            formCard.get('Altura_camada_m').setValue(data.formulario.altura_camada_m);
            formCard.get('Inicio_ressecagem_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_ressecagem, true));
            formCard.get('Inicio_ressecagem_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_ressecagem, false));
            formCard.get('Termino_ressecagem_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.termino_ressecagem, true));
            formCard.get('Termino_ressecagem_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.termino_ressecagem, false));
        }

    }

    private updateFormIII(data: any, formCard: FormGroup, generalService: GeneralService): void {
        formCard.get('Inicio_debulha_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_debulha, true));
        // tslint:disable-next-line: max-line-length
        formCard.get('Inicio_debulha_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_debulha, false));
        // tslint:disable-next-line: max-line-length
        formCard.get('Termino_debulha_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.termino_debulha, true));
        // tslint:disable-next-line: max-line-length
        formCard.get('Termino_debulha_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.termino_debulha, false));
        formCard.get('Motivo_espera_debulha').setValue(data.formulario.motivo_espera_debulha);
        formCard.get('Umidade_minima').setValue(data.formulario.umidade_minima);
        formCard.get('Umidade_maxima').setValue(data.formulario.umidade_maxima);
        formCard.get('Umidade_debulha_media').setValue(data.formulario.umidade_debulha_media);
        formCard.get('Desvio_padrao').setValue(data.formulario.desvio_padrao);
        formCard.get('Peneira_topo_utilizada').setValue(data.formulario.peneira_topo_utilizada);
        formCard.get('Retido_na_peneira_topo').setValue(data.formulario.retido_na_peneira_topo);
        formCard.get('Peneira_fundo_utilizada').setValue(data.formulario.peneira_fundo_utilizada);
        formCard.get('Vazado_na_peneira_fundo').setValue(data.formulario.vazado_na_peneira_fundo);
        formCard.get('Linha_da_debulha').setValue(data.formulario.linha_da_debulha);
    }

    private updateFormIV(data: any, formCard: FormGroup, generalService: GeneralService): void {

        if (this.areaSelect.includes('Pré-Básica')) {
            formCard.get('secagem_horas').setValue(data.formulario.secagem_horas);
            formCard.get('ressecagem_horas').setValue(data.formulario.ressecagem_horas);
            formCard.get('tempo_de_patio').setValue(data.formulario.tempo_de_patio);
        }
        else {
            formCard.get('Enchimento_horas_atividade_1010').setValue(data.formulario.enchimento_horas_atividade_1010);
            // tslint:disable-next-line: max-line-length
            formCard.get('Primeiro_ciclo_horas').setValue(data.formulario.primeiro_ciclo_horas);
            // tslint:disable-next-line: max-line-length
            formCard.get('Segundo_ciclo_horas').setValue(data.formulario.segundo_ciclo_horas);
            // tslint:disable-next-line: max-line-length
            formCard.get('Ressecagem_horas').setValue(data.formulario.ressecagem_horas);
            // tslint:disable-next-line: max-line-length
            formCard.get('Secagem_horas_atividade_2010').setValue(data.formulario.secagem_horas_atividade_2010);
            formCard.get('Espera_horas').setValue(data.formulario.espera_horas);
            formCard.get('Debulha_horas_atividade_3010').setValue(data.formulario.debulha_horas_atividade_3010);
        }

    }

    private updateFormV(data: any, formCard: FormGroup, generalService: GeneralService): void {

        if (!this.areaSelect.includes('Pré-Básica')) {
            //  formCard.get('Peso_debulha_kg').setValue(data.formulario.peso_debulha_kg);
            //  formCard.get('Lote_ds').setValue(data.formulario.lote_ds);
            //  formCard.get('Silo_destino').setValue(data.formulario.silo_destino);
            formCard.get('Status_silo').setValue(data.formulario.status_silo);
            formCard.get('Ordem_ds').setValue(data.formulario.ordem_ds);
            formCard.get('peso_debulha_kg_total').setValue(data.formulario.peso_debulha_kg_total);
            formCard.get('Volume_calda_litros').setValue(data.formulario.volume_calda_litros);
            formCard.get('Calda_por_tonelada_l_ton').setValue(data.formulario.calda_por_tonelada_l_ton);
            // tslint:disable-next-line: max-line-length
            formCard.get('Concentracao_k_obiol').setValue(data.formulario.concentracao_k_obiol);
            // tslint:disable-next-line: max-line-length
            formCard.get('Concentracao_actellic').setValue(data.formulario.concentracao_actellic);
            // tslint:disable-next-line: max-line-length
            formCard.get('K_obiol_litros').setValue(data.formulario.k_obiol_litros);
            // tslint:disable-next-line: max-line-length
            formCard.get('Actellic_litros').setValue(data.formulario.actellic_litros);
            formCard.get('Check_sap_rw').setValue(data.formulario.check_sap_rw);
            formCard.get('Check_sap_ds').setValue(data.formulario.check_sap_ds);
            formCard.get('Check_sap_quimicos').setValue(data.formulario.check_sap_quimicos);
            // tslint:disable-next-line: max-line-length
        }

    }

    private updateFormVI(data: any, formCard: FormGroup, generalService: GeneralService): void {

        if (this.areaSelect.includes('Comercial')) {
            formCard.get('Inicio_transilagem_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_da_transilagem, true));
            // tslint:disable-next-line: max-line-length
            formCard.get('Inicio_transilagem_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_da_transilagem, false));
            formCard.get('Silo_destino_transilagem').setValue(data.formulario.silo_destino_transilagem);
            formCard.get('Motivo').setValue(data.formulario.motivo);
            formCard.get('Inicio_retirada_armazem_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_da_retirada_para_armazem, true));
            // tslint:disable-next-line: max-line-length
            formCard.get('Inicio_retirada_armazem_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_da_retirada_para_armazem, false));
            formCard.get('Inicio_retorno_silo_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_da_retorno_silo, true));
            // tslint:disable-next-line: max-line-length
            formCard.get('Inicio_retorno_silo_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_da_retorno_silo, false));
            formCard.get('Silo_destino_retorno').setValue(data.formulario.silo_de_destino_retorno);
            formCard.get('Local_atual').setValue(data.formulario.local_atual);
            formCard.get('Inicio_descarga_silo_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_descarga_silo, true));
            // tslint:disable-next-line: max-line-length
            formCard.get('Inicio_descarga_silo_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_descarga_silo, false));
            formCard.get('Destino_ds_final').setValue(data.formulario.destino_ds_final);
            formCard.get('Armazenagem_dias').setValue(data.formulario.armazenagem_dias);
        }


    }

    private updateFormVII(data: any, formCard: FormGroup, generalService: GeneralService): void {

        if (this.areaSelect.includes('Pré-Básica')) {
            formCard.get('Faixa_azul_campo').setValue(data.formulario.faixa_azul_campo);
            formCard.get('Faixa_azul_umidade_de_colheita').setValue(data.formulario.faixa_azul_umidade_de_colheita);
            formCard.get('Faixa_azul_ressecagem').setValue(data.formulario.faixa_azul_ressecagem);
            formCard.get('faixa_azul_tempo_de_patio').setValue(data.formulario.faixa_azul_tempo_de_patio);
        }
        else {
            // tslint:disable-next-line: max-line-length
            formCard.get('Faixa_azul_campo').setValue(data.formulario.faixa_azul_campo);
            // tslint:disable-next-line: max-line-length
            formCard.get('Faixa_azul_umidade_de_colheita').setValue(data.formulario.faixa_azul_umidade_de_colheita);
            // tslint:disable-next-line: max-line-length
            formCard.get('Faixa_azul_temperatura_de_secagem').setValue(data.formulario.faixa_azul_temperatura_de_secagem);
            // tslint:disable-next-line: max-line-length
            formCard.get('Faixa_azul_sem_vapor_ou_ventilacao').setValue(data.formulario.faixa_azul_sem_vapor_ou_ventilacao);
            formCard.get('Faixa_azul_ressecagem').setValue(data.formulario.faixa_azul_ressecagem);
            formCard.get('Faixa_azul_transbordo').setValue(data.formulario.faixa_azul_transbordo);
            formCard.get('Faixa_azul_claro_temperatura_carga').setValue(data.formulario.faixa_azul_claro_temperatura_carga);
            formCard.get('Faixa_azul_claro_tempo_de_patio').setValue(data.formulario.faixa_azul_claro_tempo_de_patio);
            formCard.get('Faixa_azul_escuro_temperatura_carga').setValue(data.formulario.faixa_azul_escuro_temperatura_carga);
            formCard.get('Faixa_azul_escuro_tempo_de_patio').setValue(data.formulario.faixa_azul_escuro_tempo_de_patio);
            formCard.get('Faixa_azul_escuro_granel_tempo_de_transporte').setValue(data.formulario.faixa_azul_escuro_granel_tempo_de_transporte);
        }

    }

    private updateFormVIII(data: any, formCard: FormGroup, generalService: GeneralService): void {
        formCard.get('Faixa_vermelha').setValue(data.formulario.faixa_vermelha);
        // tslint:disable-next-line: max-line-length

        if (this.areaSelect.includes('Pré-Básica')) {
            // tslint:disable-next-line: max-line-length
            // formCard.get('Faixa_marrom').setValue(data.formulario.faixa_marrom);
        }
        else {
            formCard.get('Faixa_roxa').setValue(data.formulario.faixa_roxa);
           // formCard.get('Faixa_marrom')?.setValue(data.formulario.faixa_marrom);
        }

    }

    private updateFormIX(data: any, formCard: FormGroup, generalService: GeneralService): void {
        // tslint:disable-next-line: max-line-length
        formCard.get('Faixa_laranja').setValue(data.formulario.faixa_laranja);
        // tslint:disable-next-line: max-line-length
        formCard.get('Faixa_cinza').setValue(data.formulario.faixa_cinza);
    }

    private updateFormX(data: any, formCard: FormGroup, generalService: GeneralService): void {
        formCard.get('Observacao').setValue(data.formulario.observacao);
        formCard.get('criado_por').setValue(data.formulario.created_by);
        if (this.areaSelect.includes('Pré-Básica'))
            formCard.get('responsavel').setValue(data.formulario.responsavel);
    }
}
